import { render, staticRenderFns } from "./SettingsExternalApps.vue?vue&type=template&id=7ac8628c&scoped=true&"
import script from "./SettingsExternalApps.vue?vue&type=script&lang=js&"
export * from "./SettingsExternalApps.vue?vue&type=script&lang=js&"
import style0 from "./SettingsExternalApps.vue?vue&type=style&index=0&id=7ac8628c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8628c",
  null
  
)

export default component.exports